import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, Paper, Button, TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import StateForm from './StateForm';
import DistrictForm from './DistrictForm';
import TalukaForm from './TalukaForm';
import VillageForm from './VillageForm';
import ProfessionForm from './ProfessionForm';
import ReligionForm from './ReligionForm';
import EducationForm from './EducationForm';
import CastCategoryForm from './CastCategoryForm';
import YojanaCategoryForm from './YojanaCategoryForm';
import CastForm from './CastForm';
import ConstituencyForm from './ConstituencyForm';
import AdCategoryForm from './AdCategoryForm';
import StateList from './StateList';
import DistrictList from './DistrictList';
import TalukaList from './TalukaList';
import VillageList from './VillageList';
import ProfessionList from './ProfessionList';
import ReligionList from './ReligionList';
import EducationList from './EducationList';
import CastCategoryList from './CastCategoryList';
import YojanaCategoryList from './YojanaCategoryList';
import CastList from './CastList';
import ConstituencyList from './ConstituencyList';
import AdCategoryList from './AdCategoryList';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`master-tabpanel-${index}`}
      aria-labelledby={`master-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `master-tab-${index}`,
    'aria-controls': `master-tabpanel-${index}`,
  };
}

const Masters = () => {
  const [mainTabValue, setMainTabValue] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState({
    0: 'list', // State: list or form
    1: 'list', // District: list or form
    2: 'list', // Taluka: list or form
    3: 'list', // Village: list or form
    4: 'list', // Profession: list or form
    5: 'list', // Religion: list or form
    6: 'list', // Education: list or form
    7: 'list', // Caste Category: list or form
    8: 'list', // Yojana Category: list or form
    9: 'list', // Caste: list or form
    10: 'list', // Constituency: list or form
    11: 'list', // Ads Category: list or form
  });
  
  // For editing - store the item being edited
  const [editItem, setEditItem] = useState({
    0: null, // State
    1: null, // District
    2: null, // Taluka
    3: null, // Village
    4: null, // Profession
    5: null, // Religion
    6: null, // Education
    7: null, // Caste Category
    8: null, // Yojana Category
    9: null, // Caste
    10: null, // Constituency
    11: null, // Ads Category
  });

  const handleMainTabChange = (event, newValue) => {
    setMainTabValue(newValue);
    setSearchQuery('');
  };

  const handleAddClick = () => {
    setViewMode({
      ...viewMode,
      [mainTabValue]: 'form'
    });
    setEditItem({
      ...editItem,
      [mainTabValue]: null
    });
    setSearchQuery('');
  };

  const handleListClick = () => {
    setViewMode({
      ...viewMode,
      [mainTabValue]: 'list'
    });
    setEditItem({
      ...editItem,
      [mainTabValue]: null
    });
    setSearchQuery('');
  };

  const handleEditItem = (item) => {
    setEditItem({
      ...editItem,
      [mainTabValue]: item
    });
    setViewMode({
      ...viewMode,
      [mainTabValue]: 'form'
    });
    setSearchQuery('');
  };

  const handleFormSuccess = () => {
    setViewMode({
      ...viewMode,
      [mainTabValue]: 'list'
    });
    setEditItem({
      ...editItem,
      [mainTabValue]: null
    });
    setSearchQuery('');
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Paper elevation={3} sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ p: 2 }}>
          Masters Management
        </Typography>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', maxWidth: '100%' }}>
          <Tabs
            value={mainTabValue}
            onChange={handleMainTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="master data tabs"
            sx={{ maxWidth: '100%' }}
          >
            <Tab label="State" {...a11yProps(0)} />
            <Tab label="District" {...a11yProps(1)} />
            <Tab label="Taluka" {...a11yProps(2)} />
            <Tab label="Village" {...a11yProps(3)} />
            <Tab label="Profession" {...a11yProps(4)} />
            <Tab label="Religion" {...a11yProps(5)} />
            <Tab label="Education" {...a11yProps(6)} />
            <Tab label="Caste Category" {...a11yProps(7)} />
            <Tab label="Yojana Category" {...a11yProps(8)} />
            <Tab label="Caste" {...a11yProps(9)} />
            <Tab label="Constituency" {...a11yProps(10)} />
            <Tab label="Ads Category" {...a11yProps(11)} />
          </Tabs>
        </Box>
      </Paper>

      {/* Action buttons - Add New / Back to List */}
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'flex-end' }}>
        {viewMode[mainTabValue] === 'list' ? (
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleAddClick}
          >
            Add New
          </Button>
        ) : (
          <Button 
            variant="outlined" 
            color="primary" 
            onClick={handleListClick}
          >
            Back to List
          </Button>
        )}
      </Box>

      {viewMode[mainTabValue] === 'list' && (
        <Box sx={{ mb: 3, maxWidth: 420 }}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search current master list..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      )}

      {/* State Tab */}
      <TabPanel value={mainTabValue} index={0}>
        {viewMode[0] === 'list' ? (
          <StateList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <StateForm 
            editState={editItem[0]} 
            onSuccess={handleFormSuccess} 
          />
        )}
      </TabPanel>

      {/* District Tab */}
      <TabPanel value={mainTabValue} index={1}>
        {viewMode[1] === 'list' ? (
          <DistrictList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <DistrictForm 
            editDistrict={editItem[1]} 
            onSuccess={handleFormSuccess} 
          />
        )}
      </TabPanel>

      {/* Taluka Tab */}
      <TabPanel value={mainTabValue} index={2}>
        {viewMode[2] === 'list' ? (
          <TalukaList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <TalukaForm 
            editTaluka={editItem[2]} 
            onSuccess={handleFormSuccess} 
          />
        )}
      </TabPanel>

      {/* Village Tab */}
      <TabPanel value={mainTabValue} index={3}>
        {viewMode[3] === 'list' ? (
          <VillageList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <VillageForm
            editVillage={editItem[3]}
            onSuccess={handleFormSuccess}
          />
        )}
      </TabPanel>

      {/* Profession Tab */}
      <TabPanel value={mainTabValue} index={4}>
        {viewMode[4] === 'list' ? (
          <ProfessionList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <ProfessionForm 
            editProfession={editItem[4]} 
            onSuccess={handleFormSuccess} 
          />
        )}
      </TabPanel>

      {/* Religion Tab */}
      <TabPanel value={mainTabValue} index={5}>
        {viewMode[5] === 'list' ? (
          <ReligionList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <ReligionForm 
            editReligion={editItem[5]} 
            onSuccess={handleFormSuccess} 
          />
        )}
      </TabPanel>

      {/* Education Tab */}
      <TabPanel value={mainTabValue} index={6}>
        {viewMode[6] === 'list' ? (
          <EducationList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <EducationForm 
            editEducation={editItem[6]} 
            onSuccess={handleFormSuccess} 
          />
        )}
      </TabPanel>

      {/* Caste Category Tab */}
      <TabPanel value={mainTabValue} index={7}>
        {viewMode[7] === 'list' ? (
          <CastCategoryList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <CastCategoryForm 
            editCategory={editItem[7]} 
            onSuccess={handleFormSuccess} 
          />
        )}
      </TabPanel>

      {/* Yojana Category Tab */}
      <TabPanel value={mainTabValue} index={8}>
        {viewMode[8] === 'list' ? (
          <YojanaCategoryList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <YojanaCategoryForm 
            editCategory={editItem[8]} 
            onSuccess={handleFormSuccess} 
          />
        )}
      </TabPanel>

      {/* Caste Tab */}
      <TabPanel value={mainTabValue} index={9}>
        {viewMode[9] === 'list' ? (
          <CastList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <CastForm 
            editCast={editItem[9]} 
            onSuccess={handleFormSuccess} 
          />
        )}
      </TabPanel>

      {/* Constituency Tab */}
      <TabPanel value={mainTabValue} index={10}>
        {viewMode[10] === 'list' ? (
          <ConstituencyList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <ConstituencyForm 
            editConstituency={editItem[10]} 
            onSuccess={handleFormSuccess} 
          />
        )}
      </TabPanel>

      {/* Ads Category (API: GET/POST /add/category) */}
      <TabPanel value={mainTabValue} index={11}>
        {viewMode[11] === 'list' ? (
          <AdCategoryList onEdit={handleEditItem} searchQuery={searchQuery} />
        ) : (
          <AdCategoryForm 
            editCategory={editItem[11]} 
            onSuccess={handleFormSuccess} 
          />
        )}
      </TabPanel>
    </Box>
  );
};

export default Masters; 